import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseBankingDepositsProps<T> = {
  filters?: {
    companyId?: string;
    page?: number;
    status?: string;
    mainFiscalDocumentPresent?: string;
    paymentMethod?: string;
    createdAtGt?: string;
    createdAtLt?: string;
  }
  mapper?: (data: any) => T
}

export const useBankingDeposits = <T,>({
  filters: { companyId, page, status, mainFiscalDocumentPresent, paymentMethod, createdAtGt, createdAtLt } = {},
  mapper = Mapper.default<T>(),
}: UseBankingDepositsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['bankingDeposits', companyId, page, status, mainFiscalDocumentPresent, paymentMethod, createdAtGt, createdAtLt],
    queryFn: () => {
      return privateAxios.get(`/banking/deposits`, {
        params: {
          page,
          'q[company_id_eq]': companyId,
          'q[status_eq]': status,
          'q[main_fiscal_document_present]': mainFiscalDocumentPresent,
          'q[payment_method_id_eq]': paymentMethod,
          'q[created_at_gteq]': createdAtGt,
          'q[created_at_lteq]': createdAtLt,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
